import { render, staticRenderFns } from "./usuarios_aguardando.vue?vue&type=template&id=959e3240&"
import script from "./usuarios_aguardando.vue?vue&type=script&lang=js&"
export * from "./usuarios_aguardando.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports